import { GraphQLError } from "@urql/core/dist/urql-core-chunk";

type FormError = {
  [key: string]: string;
};

export const prepareFormErrors = (errors: GraphQLError[]): FormError => {
  const errorsObject: FormError = {};

  errors.map((error) => {
    // @ts-ignore
    const fieldKey = error?.originalError?.key;
    errorsObject[fieldKey] = error.originalError?.message as string;
  });

  return errorsObject;
};
